/**
 * True when checkout is rendered inside an iframe rather than owning the page.
 *
 * Comparing the two window references is the only reliable test: when the
 * embedding page is on a different origin, reading any *property* of
 * `window.top` throws, but comparing the references themselves does not.
 *
 * Server-side there is no window, and checkout is not framed in any meaningful
 * sense, so SSR reports false.
 */
export const isFramed = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch {
    // Only reachable if accessing `top` itself throws. That can only happen
    // when there is a cross-origin ancestor, which means we are framed.
    return true;
  }
};
